/* Busca e links diretos da página de perguntas frequentes (sections/fg-pagina-faq.liquid). */
(() => {
    const raiz = document.querySelector('.fgf'); if (!raiz) return;
    const campo = raiz.querySelector('#fgf-q'), status = raiz.querySelector('#fgf-status');
    const perguntas = [...raiz.querySelectorAll('.fgf-q')], grupos = [...raiz.querySelectorAll('.fgf-grupo')];
    const vazio = raiz.querySelector('.fgf-vazio');
    const norm = s => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    const textos = perguntas.map(d => norm(d.textContent));

    // link direto para uma pergunta (#fgf-recarga-1) já abre a resposta
    const abreHash = () => { const alvo = location.hash && raiz.querySelector(location.hash); if (alvo && alvo.matches('.fgf-q')) alvo.open = true; };
    abreHash(); addEventListener('hashchange', abreHash);

    let espera;
    campo.addEventListener('input', () => {
      clearTimeout(espera);
      espera = setTimeout(() => {
        // radical simples: "recarregar" também acha "recarrego" e "recarregado"
        const termos = norm(campo.value.trim()).split(/\s+/).filter(Boolean).map(t => t.length > 5 ? t.slice(0, -2) : t);
        let achadas = 0;
        perguntas.forEach((d, i) => {
          const ok = termos.every(t => textos[i].includes(t));
          d.hidden = !ok; if (ok) achadas++;
          // com busca ativa, as respostas encontradas já aparecem abertas
          d.open = termos.length > 0 && ok;
        });
        grupos.forEach(g => { g.hidden = !g.querySelector('.fgf-q:not([hidden])'); });
        vazio.hidden = achadas > 0;
        vazio.querySelector('span').textContent = campo.value.trim();
        status.textContent = termos.length ? (achadas ? achadas + (achadas > 1 ? ' perguntas encontradas' : ' pergunta encontrada') : 'Nenhuma pergunta encontrada') : '';
      }, 120);
    });
  })();
